import { createAsyncThunk } from '@reduxjs/toolkit'
import { BASE_URL, S3_BUCKET_NAME } from '../config'
import { RootState } from '../store'
import { getIDToken } from '../utils/AuthUtil'
import { isDevelop } from '../utils/Common'
import {
  setIsTakeOffCalculationInProgress,
  updateTakeOffCalculation,
} from '../actions/takeOff'
import { splitS3FilePath } from '../utils/ServiceUtil'

export const fetchTakeOffCalculationAsync = createAsyncThunk(
  'file/fetchTakeOffCalculation',
  async ({ signal }: { signal: AbortSignal }, { getState, dispatch }) => {
    const state = getState() as RootState
    const filepath = isDevelop() ? ' ' : state.organization.selectedFile?.path

    if (!filepath) {
      console.warn('Selected file is undefined.')
      return
    }

    dispatch(updateTakeOffCalculation(null))

    const { s3_folder, s3_file } = splitS3FilePath(filepath)
    const requestBody = isDevelop()
      ? {}
      : {
          file: {
            s3_bucketname: S3_BUCKET_NAME,
            s3_folder,
            s3_file,
          },
        }

    const promise = isDevelop()
      ? fetch('takeOff.json')
      : fetch(`${BASE_URL}/api/files/takeoff`, {
          signal,
          method: 'POST',
          headers: {
            'Access-Control-Allow-Origin': '*',
            Authorization: `Bearer ${await getIDToken()}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestBody),
        })

    try {
      const response = await promise
      if (!response.ok) {
        throw await response.json()
      }

      const data = await response.json()
      dispatch(
        updateTakeOffCalculation({
          ...data,
          // TODO: Temporary solution
          ...{
            costPerSqft: 250,
            energyEfficiency: 91,
            validationOptimization: 89,
          },
        }),
      )
      dispatch(setIsTakeOffCalculationInProgress(false))
    } catch (error: any) {
      if (error.name !== 'AbortError') {
        console.error(`Error during performing Take Off Calculations: `, error)
        dispatch(setIsTakeOffCalculationInProgress(false))
      }

      dispatch(updateTakeOffCalculation(null))
    }
  },
)
